import { InitialsAvatar } from '@/client/components/common/InitialsAvatar';

export function AvatarStack({
  names,
  size = 24,
  max = 3,
}: {
  names: string[];
  size?: number;
  max?: number;
}) {
  const visible = names.slice(0, max);
  const overflow = names.length - max;
  return (
    <div className="flex items-center">
      {visible.map((name, i) => (
        <div
          key={`${name}-${i}`}
          className="rounded-full ring-2 ring-background"
          style={{
            marginLeft: i === 0 ? 0 : -(size * 0.3),
            position: 'relative',
            zIndex: visible.length - i,
          }}
        >
          <InitialsAvatar name={name || '?'} size={size} />
        </div>
      ))}
      {overflow > 0 && <span className="ml-1.5 text-xs text-muted-foreground">+{overflow}</span>}
    </div>
  );
}
